import React from 'react';
import { UI_TEXT } from '../constants/FormConstants';

/**
 * Form Status Banners Component
 * Displays banners for readonly and terminated modes
 */
export const FormStatusBanners = ({
  readOnly,
  isTest,
  isTerminated,
}) => {
  return (
    <>
      {/* Readonly/Terminated Banners for non-test forms */}
      {readOnly && !isTest && (
        <>
          <div
            className={`annotation-mode-active ${isTerminated ? 'terminated' : 'readonly'}`}
          />
          <div
            className={`annotation-mode-banner ${isTerminated ? 'terminated' : 'readonly'}`}
          >
            {isTerminated
              ? UI_TEXT.FORM_TERMINATED_MESSAGE
              : UI_TEXT.FORM_READONLY_MESSAGE}
          </div>
        </>
      )}

      {/* Terminated Banner for non-readonly, non-test forms */}
      {!readOnly && !isTest && isTerminated && (
        <>
          <div className="annotation-mode-active terminated" />
          <div className="annotation-mode-banner terminated">
            {UI_TEXT.FORM_TERMINATED_MESSAGE}
          </div>
        </>
      )}
    </>
  );
};

export default FormStatusBanners;
